/* eslint-disable max-depth */
import { Islands } from '../islands.class';
import { GroupAppliances, GroupAppliancesAppliances } from '../types';

export const groupAppliancesCfn = (islands: Islands): GroupAppliances => {
	const group: GroupAppliances = {
		numApplianceTypes: 0,
		numAppliances: 0,
		appliances: {} as GroupAppliancesAppliances
	};

	for (const island of (islands.children || [])) {
		for (const panel of (island.panels.children || [])) {
			for (const panelItemGroup of (panel.panelItemGroups.children || [])) {
				for (const panelItem of (panelItemGroup.items.children || [])) {
					if (['VENT-BACK', 'VENT-SIDE', 'PASSTHROU'].indexOf(panelItem.item.sku.substr(0, 9)) === -1) {
						if (typeof group.appliances[panelItem.item.sku] === 'undefined') {
						// found the first one
							group.numApplianceTypes++;
							group.appliances[panelItem.item.sku] = {
								quantity: 1,
								sku: panelItem.item.sku,
								description: panelItem.description
								// ((skuData[panelItem.item.sku]) as SkuItem).description
							};
						} else {
						// we already have one
							group.appliances[panelItem.item.sku].quantity++;
						}

						group.numAppliances++;
					}
				}
			}
		}
	}

	return group;
};
